import Wellness from './Wellness';

export default Wellness;